import { defineMessages } from 'react-intl'

const messages = defineMessages({
  error: {
    id: 'Error.error',
    description: 'Mensaje de error',
    defaultMessage: 'No se han podido recuperar los datos'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/components/Error/messages.js